import { render, staticRenderFns } from "./InfoTestTable.vue?vue&type=template&id=a83ed4dc&scoped=true"
import script from "./InfoTestTable.vue?vue&type=script&lang=js"
export * from "./InfoTestTable.vue?vue&type=script&lang=js"
import style0 from "./InfoTestTable.vue?vue&type=style&index=0&id=a83ed4dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83ed4dc",
  null
  
)

export default component.exports